import Phaser from 'phaser';
import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router';
import store from '@/store';
/**
 *
 */
EDC.Games.AutoContinue.Scenes.Main = function () {};

const autoContinue = EDC.Games.AutoContinue.Scenes.Main.prototype;

autoContinue.init = function () {
  this.bg = null;
  this.content = null;
  this.cursorManager = null;
  this.logo = null;
  this.scale.off('resize', this.resize, this);
};

autoContinue.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);

  this.bg = this.add.image(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();

  this.logo = this.add.image(0, 0, 'logo');
  this.logo.init_scale = 1;

  const continueFrame = this.add.image(0, 0, 'continue-frame');
  const continueFrameHover = this.add.image(0, 0, 'continue-frame-hover').setVisible(false);
  continueFrameHover.setDisplaySize(continueFrame.displayWidth, continueFrame.displayHeight);
  const continueArr = this.add.image(-25, -90, 'continue-arr');
  const continueText = this.add.image(0, 85, 'continue-text');
  const continueBtn = this.add.container(this.scale.width / 2 + 70, 400, [
    continueFrame,
    continueFrameHover,
    continueArr,
    continueText,
  ]);

  const sign = this.add.image(this.scale.width / 2 + 70, 780, 'or-sign');

  const switchBtnFrame = this.add.image(0, 0, 'btn-frame');
  const switchBtnHover = this.add.image(0, 0, 'btn-frame-hover').setVisible(false);
  const switchBtnLeftIcon = this.add.image(-290, 0, 'swith-btn-icon');
  const switchBtnRightIcon = this.add.image(300, 0, 'swith-btn-icon');
  const switchBtnText = this.add.image(0, 0, 'swith-btn-text');
  const switchBtn = this.add.container(this.scale.width / 2 + 70, 920, [
    switchBtnFrame,
    switchBtnHover,
    switchBtnLeftIcon,
    switchBtnRightIcon,
    switchBtnText,
  ]);

  const continueBtnWidth = continueBtn.getBounds().width;
  const continueBtnHeight = continueBtn.getBounds().height;
  const switchBtnWidth = switchBtn.getBounds().width;
  const switchBtnHeight = switchBtn.getBounds().height;

  const continueBtnHitArea = new Phaser.Geom.Rectangle(
    -continueBtnWidth / 2,
    -continueBtnHeight / 2,
    continueBtnWidth,
    continueBtnHeight,
  );
  const switchBtnHitArea = new Phaser.Geom.Rectangle(
    -switchBtnWidth / 2,
    -switchBtnHeight / 2,
    switchBtnWidth,
    switchBtnHeight,
  );
  continueBtn.setInteractive(continueBtnHitArea, Phaser.Geom.Rectangle.Contains);
  switchBtn.setInteractive(switchBtnHitArea, Phaser.Geom.Rectangle.Contains);

  continueBtn.on('pointerdown', this.runALI);
  continueBtn.on('pointerover', () => {
    continueBtn.getAt(1).setVisible(true);
  });
  continueBtn.on('pointerout', () => {
    continueBtn.getAt(1).setVisible(false);
  });

  switchBtn.on('pointerdown', this.goToModePicker);
  switchBtn.on('pointerover', () => {
    switchBtn.getAt(1).setVisible(true);
  });
  switchBtn.on('pointerout', () => {
    switchBtn.getAt(1).setVisible(false);
  });

  this.cursorManager.setDefaultDraggableEvents(continueBtn);
  this.cursorManager.setDefaultDraggableEvents(switchBtn);

  this.content.add([continueBtn, sign, switchBtn]);

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });

  this.tweens.add({
    targets: continueArr,
    ease: 'Sine.easeInOut',
    duration: 1000,
    x: 25,
    loop: -1,
    yoyo: true,
  });
  // Bounce title
  this.tweens.add({
    targets: continueText,
    ease: 'Bounce.easeOut',
    duration: 1000,
    y: 120,
    loop: -1,
    yoyo: true,
  });
  // Bounce title
  this.tweens.add({
    targets: continueText,
    ease: "Bounce.easeOut",
    duration: 1000,
    y: 120,
    loop: - 1,
    yoyo: true
  });  
};

autoContinue.runALI = function () {
  store.dispatch('gameConfig/runALI');
};

autoContinue.goToModePicker = function () {
  localStorage.removeItem('ALI');
  router.push({ name: 'next-game' });
};

autoContinue.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;
  this.cameras.resize(width, height);
  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);
  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.7) / contentWidth;
  const scaleY = (height * 0.7) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition(
    (width - bounds.width) / 2 - 190 * neededScale,
    height / 2 - bounds.height + 360 * neededScale,
  );

  this.logo.setScale(this.logo.init_scale * neededScale);
  this.logo.setPosition(
    this.content.x + bounds.width / 2 - 595 * neededScale,
    this.content.y + 110 * neededScale,
  );
};

export default EDC.Games.AutoContinue.Scenes.Main;
